import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import CatProvider from "./contexts/CatContext";
import LangPovider from "./contexts/LangContext";
import App from './App';
import "./index.css";

const initReact = () => {
  const rootElement = document.getElementById('root');
  
  if (rootElement) {
    
    try {
      const root = ReactDOM.createRoot(rootElement);
      
      // Get the basename from the WordPress site URL
      const wpUrl = window.location.pathname;
      const basename = wpUrl.includes('/wp-content')
        ? wpUrl.substring(0, wpUrl.indexOf('/wp-content'))
        : '';
      
      console.log('Using basename:', basename);
      
      root.render(
        <BrowserRouter basename={basename}>
          <LangPovider>
            <CatProvider>
              <App />
            </CatProvider>
          </LangPovider>
        </BrowserRouter>
      );
      
    } catch (error) {
      console.error('Error rendering React:', error);
    }
  } else {
    console.error('Root element not found. Make sure there is a div with id="root" in the page.');
  }
};

// Initialize React when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReact);
} else {
  initReact();
}
